import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { MissionVision } from './components/MissionVision';
import { InsuranceCoverage } from './components/InsuranceCoverage';
import { CoreServices } from './components/CoreServices';
import { AboutInsurance } from './components/AboutInsurance';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { Button } from './components/ui/Button';
import { Menu, X, ChevronDown, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [mobileExpandedMenu, setMobileExpandedMenu] = useState<string | null>(null);
  const [mobileExpandedSubmenu, setMobileExpandedSubmenu] = useState<string | null>(null);
  const toggleDropdown = (menu: string) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };
  const toggleMobileMenu = (menu: string) => {
    setMobileExpandedMenu(mobileExpandedMenu === menu ? null : menu);
    setMobileExpandedSubmenu(null);
  };
  const toggleMobileSubmenu = (submenu: string) => {
    setMobileExpandedSubmenu(mobileExpandedSubmenu === submenu ? null : submenu);
  };
  return <div className="min-h-screen bg-white text-brand-black selection:bg-brand-red selection:text-white" data-id="element-0">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-1">
        <div className="container mx-auto px-4 md:px-6 h-20 flex items-center justify-between" data-id="element-2">
          <div className="flex items-center gap-3" data-id="element-3">
            <img src="https://cdn.magicpatterns.com/uploads/woWdE3SqvP2mw6xTq283GZ/Screenshot_2025-12-07_085625.png" alt="Absolute Insurance Brokers" className="h-10 md:h-12 w-auto" data-id="element-4" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 font-medium text-sm text-gray-600" data-id="element-5">
            <a href="#" className="hover:text-brand-black transition-colors" data-id="element-6">
              Home
            </a>

            {/* About Us Dropdown */}
            <div className="relative" onMouseEnter={() => setActiveDropdown('about')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-7">
              <button className="flex items-center gap-1 hover:text-brand-black transition-colors" data-id="element-8">
                About Us <ChevronDown className="h-4 w-4" data-id="element-9" />
              </button>
              <AnimatePresence data-id="element-10">
                {activeDropdown === 'about' && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-2xl shadow-xl border border-gray-100 py-2 overflow-hidden" data-id="element-11">
                    <a href="#" className="block px-6 py-3 hover:bg-red-50 hover:text-brand-red transition-colors" data-id="element-12">
                      Who We Are
                    </a>
                    <a href="#" className="block px-6 py-3 hover:bg-red-50 hover:text-brand-red transition-colors" data-id="element-13">
                      Management Team
                    </a>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Products Dropdown */}
            <div className="relative" onMouseEnter={() => setActiveDropdown('products')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-14">
              <button className="flex items-center gap-1 hover:text-brand-black transition-colors" data-id="element-15">
                Products <ChevronDown className="h-4 w-4" data-id="element-16" />
              </button>
              <AnimatePresence data-id="element-17">
                {activeDropdown === 'products' && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 mt-2 w-[600px] bg-white rounded-2xl shadow-xl border border-gray-100 p-6 overflow-hidden" data-id="element-18">
                    <div className="grid grid-cols-2 gap-6" data-id="element-19">
                      {/* Life Insurance Products */}
                      <div data-id="element-20">
                        <h3 className="font-bold text-brand-black mb-3 text-base" data-id="element-21">
                          Life Insurance Products
                        </h3>
                        <div className="space-y-1" data-id="element-22">
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-23">
                            Group Life Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-24">
                            Group Mortgage Protection
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-25">
                            Credit Life Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-26">
                            Health Insurance
                          </a>
                        </div>
                      </div>

                      {/* General Insurance Products */}
                      <div data-id="element-27">
                        <h3 className="font-bold text-brand-black mb-3 text-base" data-id="element-28">
                          General Insurance Products
                        </h3>
                        <div className="space-y-1 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar" data-id="element-29">
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-30">
                            Burglary / Theft Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-31">
                            Fire & Special Perils Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-32">
                            Business Interruption Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-33">
                            Machinery Breakdown Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-34">
                            Public / Product Liability Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-35">
                            Group Personal Accident Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-36">
                            Fidelity Guarantee Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-37">
                            Electronic Equipment Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-38">
                            Aviation Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-39">
                            Industrial All Risk Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-40">
                            Marine (Cargo & Hull) Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-41">
                            Plant All Risk Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-42">
                            Directors' & Officers' Liability Insurance
                          </a>
                          <a href="#" className="block px-4 py-2 rounded-lg hover:bg-red-50 hover:text-brand-red transition-colors text-sm" data-id="element-43">
                            Goods in Transit Insurance
                          </a>
                        </div>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <a href="#" className="hover:text-brand-black transition-colors" data-id="element-44">
              Services
            </a>
            <a href="#" className="hover:text-brand-black transition-colors" data-id="element-45">
              Contact Us
            </a>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4" data-id="element-46">
            <Button size="sm" data-id="element-47">Get a Quote</Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-gray-600 hover:text-brand-black transition-colors" data-id="element-48">
            {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-49" /> : <Menu className="h-6 w-6" data-id="element-50" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-51">
          {mobileMenuOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-52">
              <div className="container mx-auto px-4 py-4 flex flex-col gap-2 max-h-[70vh] overflow-y-auto" data-id="element-53">
                <a href="#" className="py-2 text-gray-600 hover:text-brand-black transition-colors font-medium" onClick={() => setMobileMenuOpen(false)} data-id="element-54">
                  Home
                </a>

                {/* About Us Mobile */}
                <div data-id="element-55">
                  <button onClick={() => toggleMobileMenu('about')} className="w-full flex items-center justify-between py-2 text-gray-600 hover:text-brand-black transition-colors font-medium" data-id="element-56">
                    About Us
                    <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedMenu === 'about' ? 'rotate-180' : ''}`} data-id="element-57" />
                  </button>
                  <AnimatePresence data-id="element-58">
                    {mobileExpandedMenu === 'about' && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="pl-4 space-y-1 overflow-hidden" data-id="element-59">
                        <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-60">
                          Who We Are
                        </a>
                        <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-61">
                          Management Team
                        </a>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                {/* Products Mobile */}
                <div data-id="element-62">
                  <button onClick={() => toggleMobileMenu('products')} className="w-full flex items-center justify-between py-2 text-gray-600 hover:text-brand-black transition-colors font-medium" data-id="element-63">
                    Products
                    <ChevronDown className={`h-4 w-4 transition-transform ${mobileExpandedMenu === 'products' ? 'rotate-180' : ''}`} data-id="element-64" />
                  </button>
                  <AnimatePresence data-id="element-65">
                    {mobileExpandedMenu === 'products' && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="pl-4 space-y-2 overflow-hidden" data-id="element-66">
                        {/* Life Insurance Mobile */}
                        <div data-id="element-67">
                          <button onClick={() => toggleMobileSubmenu('life')} className="w-full flex items-center justify-between py-2 text-sm text-gray-600 hover:text-brand-black font-medium" data-id="element-68">
                            Life Insurance Products
                            <ChevronRight className={`h-4 w-4 transition-transform ${mobileExpandedSubmenu === 'life' ? 'rotate-90' : ''}`} data-id="element-69" />
                          </button>
                          <AnimatePresence data-id="element-70">
                            {mobileExpandedSubmenu === 'life' && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} className="pl-4 space-y-1 overflow-hidden" data-id="element-71">
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-72">
                                  Group Life Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-73">
                                  Group Mortgage Protection
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-74">
                                  Credit Life Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-75">
                                  Health Insurance
                                </a>
                              </motion.div>}
                          </AnimatePresence>
                        </div>

                        {/* General Insurance Mobile */}
                        <div data-id="element-76">
                          <button onClick={() => toggleMobileSubmenu('general')} className="w-full flex items-center justify-between py-2 text-sm text-gray-600 hover:text-brand-black font-medium" data-id="element-77">
                            General Insurance Products
                            <ChevronRight className={`h-4 w-4 transition-transform ${mobileExpandedSubmenu === 'general' ? 'rotate-90' : ''}`} data-id="element-78" />
                          </button>
                          <AnimatePresence data-id="element-79">
                            {mobileExpandedSubmenu === 'general' && <motion.div initial={{
                        height: 0,
                        opacity: 0
                      }} animate={{
                        height: 'auto',
                        opacity: 1
                      }} exit={{
                        height: 0,
                        opacity: 0
                      }} className="pl-4 space-y-1 overflow-hidden" data-id="element-80">
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-81">
                                  Burglary / Theft Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-82">
                                  Fire & Special Perils Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-83">
                                  Business Interruption Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-84">
                                  Machinery Breakdown Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-85">
                                  Public / Product Liability Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-86">
                                  Group Personal Accident Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-87">
                                  Fidelity Guarantee Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-88">
                                  Electronic Equipment Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-89">
                                  Aviation Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-90">
                                  Industrial All Risk Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-91">
                                  Marine (Cargo & Hull) Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-92">
                                  Plant All Risk Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-93">
                                  Directors' & Officers' Liability Insurance
                                </a>
                                <a href="#" className="block py-2 text-sm text-gray-600 hover:text-brand-red" onClick={() => setMobileMenuOpen(false)} data-id="element-94">
                                  Goods in Transit Insurance
                                </a>
                              </motion.div>}
                          </AnimatePresence>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <a href="#" className="py-2 text-gray-600 hover:text-brand-black transition-colors font-medium" onClick={() => setMobileMenuOpen(false)} data-id="element-95">
                  Services
                </a>
                <a href="#" className="py-2 text-gray-600 hover:text-brand-black transition-colors font-medium" onClick={() => setMobileMenuOpen(false)} data-id="element-96">
                  Contact Us
                </a>
                <Button size="md" className="w-full mt-2" data-id="element-97">
                  Get a Quote
                </Button>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>

      <main data-id="element-98">
        <Hero data-id="element-99" />
        <MissionVision data-id="element-100" />
        <InsuranceCoverage data-id="element-101" />
        <CoreServices data-id="element-102" />
        <AboutInsurance data-id="element-103" />
        <Testimonials data-id="element-104" />
        <CTASection data-id="element-105" />
      </main>

      <Footer data-id="element-106" />
    </div>;
}